import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Internal tailwind-aware class merger for custom icon components.
 * Mirrors the `cn` helper in @gat-ship/vue-components but lives here so
 * the icons package doesn't depend on vue-components (which would create
 * a dep cycle, since vue-components depends on @gat-ship/icons).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
